import { store } from '../app/store';
import actions from '../app/notification/actions';
import { AppNotificationType } from '../models/AppNotification';
import { stringType } from 'aws-sdk/clients/iam';

export interface NotificationHelperPushOptions {
  silent?: boolean;
  type?: AppNotificationType;
  title?: string;
  duration?: number;
  alwaysToast?: boolean;
}

export interface NotificationHelperToastOptions {
  silent?: boolean;
  title?: string;
  duration?: number;
}

export class NotificationHelper {
  public static push(message: string, { title, silent, type, duration, alwaysToast }: NotificationHelperPushOptions = {}): void {
    store.dispatch(actions.push({ time: new Date().getTime(), title, message, silent, type, duration, alwaysToast }));
  }

  public static toastError(message: stringType, options: NotificationHelperToastOptions = {}): void {
    const pushOptions = options as NotificationHelperPushOptions;
    pushOptions.type = AppNotificationType.ERROR;
    pushOptions.alwaysToast = true;
    NotificationHelper.push(message, pushOptions);
  }

  public static toastSuccess(message: stringType, options: NotificationHelperToastOptions = {}): void {
    const pushOptions = options as NotificationHelperPushOptions;
    pushOptions.type = AppNotificationType.SUCCESS;
    pushOptions.alwaysToast = true;
    NotificationHelper.push(message, pushOptions);
  }
}
